import React, { forwardRef } from 'react'
import { Popover } from 'react-tiny-popover'

export function FilterPopover({isOpen, closePopup, filterKey = null, children}) {
    const childArray = React.Children.toArray(children).filter(React.isValidElement)

    const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => 'field_' + f.id === filterKey) ?? null);

    const content = childArray.find(child => child.type === FilterPopoverContent)
    const wrapped = childArray.find(child => child.type === FilterPopoverWrapped)

    const FilterPopoverTitle = () => {
        if (dashboardField) return dashboardField.name;
        if (filterKey === 'organisation_id') return 'Organisation';
        if (filterKey === null) return 'Add Filter';
        return 'Filter';
    }

    const popoverContent = () => {
        return <div className="filter-popover-container" onClick={(e) => e.stopPropagation()}>
            {/* Only show this title bit on mobile */}
            <div className="filter-popover-header">
                <span className="filter-popover-title"><FilterPopoverTitle /></span>
                <a className="filter-popover-close" href="#" onClick={closePopup}><SvgIconsClose /></a>
            </div>
            {content}
        </div>
    }

    const handleClickOutside = (e) => {
        // Check if any parent is a modal, and if so don't close the popover - this allows popovers to be used inside modals without immediately closing when clicking inside them
        let node = e?.target;
        if (node && node.nodeType !== 1) {
            node = node.parentElement;
        }

        while (node) {
            if (node.classList?.contains('modal-root')) {
                return;
            }
            node = node.parentElement;
        }

        closePopup();
    }

    return <Popover
                isOpen={isOpen}
                positions={['bottom', 'top', 'right', 'left']}
                padding={10}
                onClickOutside={handleClickOutside}
                containerStyle={{ zIndex: '999' }}
                containerClassName='dashboard-filter-popover mobile-full-popover'
                content={popoverContent()}
            >
                {wrapped}
            </Popover>
}

export function FilterPopoverContent({children}) {
    return <div className="filter-popover-content">
        {children}
    </div>
}

export const FilterPopoverWrapped = forwardRef(function FilterPopoverWrapped({children, className = ''}, ref) {
    return <div className={`filter-popover-container ${className}`} ref={ref}>
        {children}
    </div>
})